export default "__VITE_ASSET__BuTFran9__"